import { render, staticRenderFns } from "./ReportWidgetWbiBreakdown.vue?vue&type=template&id=4836139f"
import script from "./ReportWidgetWbiBreakdown.vue?vue&type=script&lang=js"
export * from "./ReportWidgetWbiBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ReportWidgetWbiBreakdown.vue?vue&type=style&index=0&id=4836139f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports